import React from "react";

import CardSection from "./cardSection";

const StripeForm = () => {
  return <CardSection />;
};

export default StripeForm;
